<template>
    <div class="panel-container show">
        <div class="panel-content">
            <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="mb-0 fw-700 text-center mt-3" v-if="this.location.id > 0">
                    {{this.location.title}}
                </h5>

                <h5 class="mb-0 fw-700 text-center mt-3" v-else>
                    {{__t("NEW_REST")}}
                </h5>
            </div>
            <div>

                <info_field f_uniq="ct" f_type="title" :is_disabled="false" @update_categ="change_atr" :f_title="__t('NAME')" :f_val="location.title"></info_field>

                <div class="form-group mt-2">
                    <label class="form-label" for="organization">
                        {{__t("LINK_PWA_LOCATION")}}
                    </label>

                    <div class="" v-if="pwa_locations.length > 0">
                        <v-select v-model="attached_location" class="imc_reasons" label="title" :options="this.draw_locations" :filterable="false">
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    <div>
                                        {{ option.title }}
                                    </div>
                                    <div>
                                        <small>
                                            {{option.uniq_id}}
                                        </small>

                                    </div>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>


                <div v-if="attached_location && attached_location.id > 0">
                    <div class="panel-tag mt-2">
                        {{__t("POS_PARAMS")}}
                    </div>

                    <location_general_params :show_auto_delivery="false" :show_choice_rest="false" :location="location"></location_general_params>

                    <!-- Location PARAMS -->
                    <div class="panel-tag mt-2">
                        {{__t("PWA_LOCATION_PARAMS")}}
                    </div>

                    <b-tabs content-class="mt-3 mb-4">
                        <b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
                               :title="get_tab_title(tab)"
                               :key="index"
                               :active="tab.is_active"
                        >
                            <template slot="title">
                                {{get_tab_title(tab)}}
                                <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                            </template>

                            <div class="general_pwa_settings" v-if="tab.index == 'pwa_shipment_settings'">
                                <pwa_shipment_settings :is_qr="true" :location="location"></pwa_shipment_settings>
                            </div>

                            <div class="general_pwa_settings" v-if="tab.index == 'pwa_main_settings'">
                                <div class="form-group mt-2" v-for="general_field in general_fields">

                                    <label class="form-label" >
                                        {{general_field.title}}
                                    </label>

                                    <div class="input-group flex-nowrap" v-if="!(is_bool_field(general_field) || is_editor(general_field))">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <i class="fal  fa-typewriter fs-xl" ></i>
                                            </span>
                                        </div>

                                        <input :id="general_field.key" type="text" class="form-control" v-model="location.general_fields[general_field.key]">
                                    </div>

                                    <div class="input-group flex-nowrap" v-if="is_bool_field(general_field)">
                                        <b-form-radio-group
                                            :id="'btn-radios-' + general_field.key"
                                            v-model="location.general_fields[general_field.key]"
                                            button-variant="outline-primary"
                                            :options="[
                                                  { text: 'YES', value: true },
                                                  { text: 'NO', value: false }
                                            ]"
                                            :name="'btn-radios-' + general_field.key"
                                            buttons
                                        ></b-form-radio-group>

                                    </div>

                                    <div class="editor" v-if="is_editor(general_field)">
                                        <vue-editor :editor-toolbar="editor_rules" v-model="location.general_fields[general_field.key]"></vue-editor>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
import { VueEditor } from "vue2-editor";
import Location_general_params from "../../../base/location_general_tab/location_general_params.vue";
import Info_field from "../../../../sys/info_field.vue";
import pwa_qr_payments from "./pwa_qr_payments.vue";
import pwa_shipment_settings from "../tabs/shipment/pwa_shipment_settings.vue";


export default {
    name: "pwa_qr_general_tab",

    components : {
        pwa_shipment_settings,
        Info_field,
        Location_general_params,
        pwa_qr_payments,
        vSelect,
        VueEditor,
    },

    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {
            pwa_locations : [],
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],

            tabs : [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "pwa_main_settings",
                    is_active:true,
                },

                {
                    "title": this.__t('PWA_PAYMENT_TAB'),
                    "index": "pwa_shipment_settings",
                    is_active:false,
                },
            ],


        }
    },

    created() {
        this.get_params();
    },

    methods : {

        async get_params() {
            this.pwa_locations = [];
            this.is_load = true;

            if(parseInt(this.provider_id) > 0) {

                this.load_locations().then(({data}) => {
                    if (data.status === "operation_success") {
                        let locations = data.data;
                        locations.map(item => {
                            item.is_loading = false;
                            item.is_checked = false;
                            this.pwa_locations.push(item);
                        })
                    }
                    this.is_load = false;
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    })
                });
            }
        },

        async load_locations() {
            return agr_api.post('/aggregators/' + this.provider_id + "/locations");
        },


        change_atr(atr_name,atr_val) {
            if(this.location.hasOwnProperty(atr_name)) {
                this.location[atr_name] = atr_val;
                this.$set(this.location,atr_name,atr_val);
            }
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }
            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },


        is_editor(field) {
            const allowed = ['description'];
            return allowed.includes(field.key);
        },

        is_bool_field(field) {
            return field && typeof field.value === 'boolean';
        },

    },
    computed: {

        draw_locations() {
            return this.pwa_locations.filter(item => {
                return item.provider === 'pwa' && item.is_qr_location == false;
            });
        },

        provider_id () {
            return this.location?.provider_id;
        },

        general_fields() {
            const skipKeys = ['id', 'shipments'];

            if (!this.location || !this.location.general_fields) {
                return [];
            }

            return Object.entries(this.location.general_fields)
                .filter(([key]) => !skipKeys.includes(key))
                .map(([key, value]) => ({
                    key,
                    value,
                    title: this.__t(key.toUpperCase())
                }));
        },

        attached_location : {
            get :function () {
                let active  = null;
                if(this.pwa_locations.length > 0) {
                    if(this.location.hasOwnProperty("link_location_id")) {
                        this.pwa_locations.map(item => {
                            if(parseInt(item.id) === parseInt(this.location.link_location_id)) {
                                active = item;
                            }
                        })
                    }
                }

                return active;
            },

            set: function (val) {
                if(val != null) {
                    this.$set(this.location,'link_location_id',val.id);
                    this.$set(this.location, 'parent_id', val.parent_id);
                    this.$set(this.location, 'link_id', val.link_id);

                    if(parseInt(this.location.id) === 0) {
                        this.$set(this.location, 'shipping_id', val.shipping_id);
                        this.$set(this.location, 'payment_id', val.shipping_id);
                    }
                }
                else {
                    this.$set(this.location,'link_location_id',0);
                    this.$set(this.location, 'parent_id', 0);
                    this.$set(this.location, 'link_id', 0);

                    if(parseInt(this.location.id) === 0) {
                        this.$set(this.location, 'shipping_id', 0);
                        this.$set(this.location, 'payment_id', 0);
                    }
                }

                EventBus.$emit('reload_rest_list');
            },
        }

    }
}
</script>

<style scoped>

</style>
